"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _Text = _interopRequireDefault(require("../Text"));

var _timer = _interopRequireDefault(require("./timer.proptypes"));

var _constant = require("./constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var TimerContainer = _styledComponents.default.div.withConfig({
  displayName: "Timer__TimerContainer",
  componentId: "sc-nwhz3-0"
})(["& > *{font-size:", ";}"], function (_ref) {
  var theme = _ref.theme,
      size = _ref.size;
  return theme.fontSize[size];
});

var CountdownWrapper = _styledComponents.default.div.withConfig({
  displayName: "Timer__CountdownWrapper",
  componentId: "sc-nwhz3-1"
})(["p{padding-right:", ";}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.space.micro;
});

var convertDateToTimeZone = function convertDateToTimeZone(date, timezone) {
  if (!timezone) {
    return new Date();
  }

  var convertedDateTime = date.toLocaleString('en-US', {
    timeZone: timezone
  });
  return new Date(convertedDateTime);
};

var Timer = function Timer(props) {
  var endDate = props.endDate,
      size = props.size,
      timeZone = props.timeZone,
      color = props.color,
      dayLabel = props.dayLabel,
      timeEndCallback = props.timeEndCallback,
      theme = props.theme,
      accessible = props.accessible,
      customProperties = props.customProperties,
      allowLocaleFormat = props.allowLocaleFormat,
      locale = props.locale,
      localeConfig = props.localeConfig,
      countDownFormat = props.countDownFormat;

  var calculateTimeLeft = function calculateTimeLeft() {
    var startingDate = convertDateToTimeZone(new Date(), timeZone);
    var timeDifference = new Date(endDate) - startingDate;
    var timeLeft = null;

    if (timeDifference > 0) {
      timeLeft = {
        days: Math.floor(timeDifference / (1000 * 60 * 60 * 24)),
        hours: Math.floor(timeDifference / (1000 * 60 * 60) % 24),
        minutes: Math.floor(timeDifference / 1000 / 60 % 60),
        seconds: Math.floor(timeDifference / 1000 % 60)
      };
      timeLeft = {
        days: timeLeft.days < 10 ? "0".concat(timeLeft.days) : timeLeft.days,
        hours: timeLeft.hours < 10 ? "0".concat(timeLeft.hours) : timeLeft.hours,
        minutes: timeLeft.minutes < 10 ? "0".concat(timeLeft.minutes) : timeLeft.minutes,
        seconds: timeLeft.seconds < 10 ? "0".concat(timeLeft.seconds) : timeLeft.seconds
      };
    }

    return timeLeft;
  };

  var _useState = (0, _react.useState)(calculateTimeLeft()),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      timeLeft = _useState2[0],
      setTimeLeft = _useState2[1];

  (0, _react.useEffect)(function () {
    var timer = setTimeout(function () {
      setTimeLeft(calculateTimeLeft());
    }, 1000); // Clear timeout if the component is unmounted

    return function () {
      return clearTimeout(timer);
    };
  });
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  var getLocaleTimeFormat = function getLocaleTimeFormat() {
    if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
      var newDate = new Date().setHours(timeLeft.hours, timeLeft.minutes, timeLeft.seconds);
      var localeToUse = locale || navigator.userLanguage || navigator.language || _constant.DEFAULT_LOCALE;
      var localeTime = '';

      try {
        localeTime = new Intl.DateTimeFormat(localeToUse, localeConfig).format(new Date(newDate));
      } catch (_unused) {
        localeTime = new Intl.DateTimeFormat(navigator.userLanguage || navigator.language || _constant.DEFAULT_LOCALE, localeConfig).format(new Date(newDate));
      }

      return localeTime;
    }

    return '';
  };

  var renderCountdownTimer = function renderCountdownTimer(minutes, seconds) {
    return /*#__PURE__*/_react.default.createElement(CountdownWrapper, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
      color: minutes < 1 ? 'primary' : 'green',
      accessible: accessible,
      customProperties: customProperties,
      theme: theme
    }, minutes === 0 ? '00' : minutes), /*#__PURE__*/_react.default.createElement(_Text.default, {
      color: color,
      accessible: accessible,
      customProperties: customProperties,
      theme: theme
    }, "min"), /*#__PURE__*/_react.default.createElement(_Text.default, {
      color: minutes < 1 ? 'primary' : 'green',
      accessible: accessible,
      customProperties: customProperties,
      theme: theme
    }, seconds === 0 ? '00' : seconds), /*#__PURE__*/_react.default.createElement(_Text.default, {
      color: color,
      accessible: accessible,
      customProperties: customProperties,
      theme: theme
    }, "sec left"));
  };

  var getMain = function getMain() {
    var remainingTime = '00 : 00 : 00';

    if (!timeLeft && timeEndCallback) {
      if (countDownFormat) {
        remainingTime = renderCountdownTimer(0, 0);
      }

      timeEndCallback();
    }

    if (timeLeft) {
      remainingTime = allowLocaleFormat ? getLocaleTimeFormat() : "".concat(timeLeft.hours, " : ").concat(timeLeft.minutes, " : ").concat(timeLeft.seconds);

      if (timeLeft.days > 0) {
        remainingTime = "".concat(timeLeft.days, " ").concat(dayLabel, " - ").concat(remainingTime);
      }

      if (countDownFormat) {
        remainingTime = renderCountdownTimer(timeLeft.minutes, timeLeft.seconds);
      }
    }

    return /*#__PURE__*/_react.default.createElement(TimerContainer, {
      size: size
    }, /*#__PURE__*/_react.default.createElement(_Text.default, {
      color: color,
      accessible: accessible,
      customProperties: customProperties,
      theme: theme
    }, remainingTime));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

Timer.propTypes = _timer.default.PropTypes;
Timer.defaultProps = _timer.default.DefaultProps;
var _default = Timer;
exports.default = _default;